import React from "react";
import AppStore from "../../../../public/AppStore.svg";
import Image from "@/app/[lang]/components/shared/SmartImage";

export const AppStoreButton = () => {
  return <Image src={AppStore} width={120} height={40} loading="lazy" decoding="async" alt="App Store" />;
};
